/**
 *
 * FreshPets Colors
 *
 */

const colors = {
    primary: '#00A29E',
    primary_light: '#00bbb7',
    primary_dark: '#008985',
    secondary: '#95C11F',
    secondary_highlight: '#a6d723',
    secondary_dark: '#84ab1b',
    tertiary: '#929084',
    white: '#fffffe',
    black: '#111122',
    text: '#000',
    background: '#fff'
}

export default colors